export enum OrderType {
  Delivery = 'Entrega',
  Picking = 'Recolección'
}
